export interface IDropdownSettings {
  singleSelection?: boolean;
  idField?: string;
  textField?: string;
  classField?: string;
  enableCheckAll?: boolean;
  selectAllText?: string;
  unSelectAllText?: string;
  allowSearchFilter?: boolean;
  clearSearchFilter?: boolean;
  maxHeight?: number;
  itemsShowLimit?: number;
  limitSelection?: number;
  searchPlaceholderText?: string;
  noDataAvailablePlaceholderText?: string;
  closeDropDownOnSelection?: boolean;
  showSelectedItemsAtTop?: boolean;
  defaultOpen?: boolean;
  matchItemDropWidthToControl?: boolean;
  resetTextValueOnSelection?: boolean;
  allowWildFilter?: boolean;
  allowAdvancedWildcardSearch?: boolean;
}

export class ListItem {
  id: any;
  text: any;
  class: any;

  public constructor(source: any) {
    if (typeof source === 'string') {
      this.id = this.text = source;
    }
    if (typeof source === 'object') {
      this.id = source.id;
      this.text = source.text;
      this.class = source.class;
    }
  }
}

export const MS_ITEM_SEPERATOR_CLASS = '-SEPERATOR-';
